import { Alert, Grid, Stack, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Loading from '../components/Loading/loading';
import AuthWrapper from '../layout/auth/auth-wrapper';
import ResetPasswordForm from '../components/reset-password/ResetPasswordForm';
import { resetPassword } from '../api/api-middleware';

function ResetPasswordPage() {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resetToken, setResetToken] = useState('');
  const [response, setResponse] = useState(null);
  const [showResponse, setShowResponse] = useState(false);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get('reset_password_token');

    if (token) {
      setResetToken(token);
    }
  }, []);

  const handleSubmit = async (values) => {
    setError(null);
    setLoading(false)
    try {
      const user = {
        password: values.password,
        passwordConfirmation: values.passwordConfirmation,
        resetPasswordToken: resetToken,
      };

      let response = await resetPassword(user);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message);
      } else {
        const successResponse = await response.json();
        setResponse(successResponse);
        setShowResponse(true);
      }
    } catch (error) {
      setError('Failed to reset the password. ' + error.message);
    }
  };

  return (
    <AuthWrapper>
      {loading ? (
        <Loading />
      ) : (
        <>
          {showResponse ? (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
                  <Typography variant="h4" gutterBottom color="success.main">
                    Success!
                  </Typography>
                  <Typography variant="subtitle2">
                    {response.message}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          ) : (
            <>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
                    <Typography variant="h4" gutterBottom>
                      Reset Password
                    </Typography>
                    <Typography variant="subtitle2">
                      Please enter your new password
                    </Typography>
                  </Stack>
                </Grid>

                <Grid item xs={12}>
                  {error ? (
                    <Alert severity="error" sx={{ mb: 2 }}>
                      {error}
                    </Alert>
                  ) : null}
                  <ResetPasswordForm onSubmit={handleSubmit} />
                </Grid>
              </Grid>
            </>
          )}
        </>
      )}
    </AuthWrapper>
  );
}

export default ResetPasswordPage;
